import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowUpRight } from "lucide-react";
import { BRAND } from "../data/content";
import { trackEvent } from "../lib/analytics";

/**
 * Mobile-only sticky bottom CTA bar.
 * Shows on every public page to lift organic conversion.
 * On desktop, the navbar CTA + WhatsApp widget are sufficient — this stays hidden.
 */
export default function MobileStickyCTA() {
  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 border-t border-white/10 bg-[#0A0F1C]/95 backdrop-blur"
      data-testid="mobile-sticky-cta"
    >
      <a
        href={`tel:${BRAND.phone.replace(/\s/g, "")}`}
        onClick={() => trackEvent("contact_phone", { location: "mobile_sticky" })}
        className="flex items-center justify-center gap-2 text-white text-sm font-semibold py-3 border-r border-white/10 active:bg-white/5"
        data-testid="sticky-cta-call"
      >
        <Phone className="w-4 h-4" /> Call
      </a>
      <Link
        to="/contact"
        onClick={() => trackEvent("request_quote_click", { location: "mobile_sticky" })}
        className="gs-gradient flex items-center justify-center gap-2 text-white text-sm font-bold py-3"
        data-testid="sticky-cta-quote"
      >
        Get Free Quote <ArrowUpRight className="w-3.5 h-3.5" />
      </Link>
    </div>
  );
}
